var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_13137)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_32_13137)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_32_13137)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32_13137",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 0.539062H0.25V16.5391H16.25V0.539062Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32_13137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 16.5391C12.6683 16.5391 16.25 12.9574 16.25 8.53906C16.25 4.12078 12.6683 0.539062 8.25 0.539062C3.83172 0.539062 0.25 4.12078 0.25 8.53906C0.25 12.9574 3.83172 16.5391 8.25 16.5391Z",
    fill: "#FE113C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.92264 7.07617L8.57904 7.9807L9.64207 7.63601L8.98464 8.53976L9.64095 9.44426L8.57829 9.09826L7.92089 10.002L7.92157 8.88448L6.85889 8.53848L7.92195 8.19379L7.92264 7.07617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13116 10.7999C4.88254 10.7999 3.87029 9.7876 3.87029 8.53897C3.87029 7.29035 4.88254 6.2781 6.13116 6.2781C6.52047 6.2781 6.88679 6.37656 7.2066 6.54985C6.70488 6.05916 6.01872 5.75635 5.2616 5.75635C3.72479 5.75635 2.479 7.00216 2.479 8.53894C2.479 10.0757 3.72482 11.3216 5.2616 11.3216C6.01878 11.3216 6.70491 11.0187 7.2066 10.528C6.88679 10.7014 6.52047 10.7999 6.13116 10.7999Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_13137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.25 0.539062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_32_13137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.25 0.539062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_32_13137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.25 0.539062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiraIcon);
export default __webpack_public_path__ + "static/media/lira-icon.a466bae0e42bd44f61cc44b301f5db4e.svg";
export { ForwardRef as ReactComponent };